export default __webpack_public_path__ + "static/media/two_stars.cc8ac8c1.svg";